/* istanbul ignore file */

import type { SVGProps } from 'react';
import { useTheme } from 'styled-components';

import type theme from '@shared/theme';

type Props = SVGProps<SVGSVGElement> & {
    fillColor?: keyof typeof theme.colors;
};

export default function AccountIcon({ fillColor, ...props }: Props) {
    const theme = useTheme();

    return (
        <svg
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            {...props}
            role="img"
        >
            <path
                fill={fillColor ? theme.colors[fillColor] : '#fff'}
                d="M6.023 18.214c.85-.63 1.776-1.129 2.778-1.494A9.263 9.263 0 0 1 12 16.172c1.13 0 2.197.183 3.199.548 1.002.365 1.928.864 2.778 1.494a7.885 7.885 0 0 0 1.478-2.373 7.711 7.711 0 0 0 .545-2.92c0-2.216-.78-4.103-2.337-5.662C16.104 5.701 14.217 4.922 12 4.922S7.896 5.7 6.338 7.259C4.779 8.818 4 10.705 4 12.922c0 1.047.182 2.02.545 2.92.364.898.856 1.689 1.478 2.372ZM12 13.672c-.913 0-1.683-.314-2.31-.94-.627-.627-.94-1.397-.94-2.31s.313-1.683.94-2.31 1.397-.94 2.31-.94 1.683.313 2.31.94.94 1.397.94 2.31-.313 1.682-.94 2.31c-.627.626-1.397.94-2.31.94Zm0 8.75a9.31 9.31 0 0 1-3.713-.744 9.536 9.536 0 0 1-3.016-2.027 9.538 9.538 0 0 1-2.027-3.017 9.311 9.311 0 0 1-.744-3.712c0-1.32.248-2.557.744-3.713a9.538 9.538 0 0 1 2.027-3.016 9.538 9.538 0 0 1 3.016-2.027A9.31 9.31 0 0 1 12 3.422a9.31 9.31 0 0 1 3.713.744 9.538 9.538 0 0 1 3.016 2.027 9.54 9.54 0 0 1 2.027 3.016 9.312 9.312 0 0 1 .744 3.713c0 1.319-.248 2.556-.744 3.712a9.54 9.54 0 0 1-2.027 3.017 9.537 9.537 0 0 1-3.016 2.027 9.31 9.31 0 0 1-3.713.744Zm0-1.5c.902 0 1.773-.145 2.61-.436a7.409 7.409 0 0 0 2.232-1.218 7.601 7.601 0 0 0-2.202-1.175 8.082 8.082 0 0 0-2.64-.421c-.941 0-1.822.139-2.644.416a7.252 7.252 0 0 0-2.198 1.18 7.41 7.41 0 0 0 2.231 1.218c.838.29 1.709.436 2.611.436Zm0-8.75c.498 0 .914-.168 1.248-.502.335-.335.502-.75.502-1.248s-.167-.914-.502-1.248c-.334-.335-.75-.502-1.248-.502s-.914.167-1.248.502c-.335.334-.502.75-.502 1.248 0 .497.167.913.502 1.248.334.335.75.502 1.248.502Z"
            />
        </svg>
    );
}
